import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'were_workers'

export const dataPointDefinition = {
  retracedId: 'were_workers',
  name: "Were workers' representatives and/or workers involved in the self/joint-assessment process?",
  description:
    "This question is asking if the facility involved workers' representatives (e.g., trade union or other workers' representatives, bipartite committee members, worker committee members) or workers in the self/joint-assessment process.",
  meta: {
    slcpMeta: {
      key: 'vd-ver-6',
      number: 'FP-BAS-27',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {type: 'object', properties: {value: {type: 'string'}}, required: ['value']},
  externalIds: [{id: 'vd-ver-6', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34740,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
